
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/identity-copilot",
      function () {
        return require("private-next-pages/sign/identity-copilot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/identity-copilot"])
      });
    }
  